import React, { Component } from "react";
import HttpsRedirect from "react-https-redirect";
import Cookies from "universal-cookie";
import RouteNavigation from "./components/routeNavigation";
import constants from "./shared/constants/environmentConfig";
import { getAccountsDomain } from "./helpers/Utils";
import "./App.css";

const Constants = constants();
const cookies = new Cookies();
const publicPaths = "/";
const paths = "/external_fee_payment/";
class App extends Component {
  render() {
    const userProfile = cookies.get("user"); 
    userProfile && setTimeout(() => { window.location.href = (`${getAccountsDomain()}/logout`) }, userProfile.screen_time? (userProfile.screen_time * 60 * 1000) : 15 * 60 * 1000);
    if (!userProfile && !publicPaths.includes(window.location.pathname) && !window.location.pathname.includes(paths)) {
      window.location.href = getAccountsDomain();
    } else if (window.location.pathname === "/" && userProfile) {
      window.location.pathname =
        userProfile.type === "Admin" ? "/dashboard" : "/student_list";
    } else if (Constants.cookie.secure) {
      return (
        <HttpsRedirect>
          <RouteNavigation userProfile={userProfile} />;
        </HttpsRedirect>
      );
    } else {
      return <RouteNavigation userProfile={userProfile} />;
    }
  }
}

export default App;
